<!--
 * @Author: 王佳宾
 * @Date: 2022-10-17 15:45:05
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2024-04-01 11:08:56
 * @Description: 项目类型
 * @FilePath: \web\src\components\DataManagement\component\typeList.vue
-->
<template>
  <a-checkbox-group v-model:value="option.selectValue" class="type-check-group">
    <a-checkbox :value="item.key" v-for="item in config.projectType" :key="item.key">{{ item.name }}</a-checkbox>
  </a-checkbox-group>
  <section v-if="option.codeType" class="code-type">
    <p>按编号导出</p>
    <a-textarea placeholder="1、如需按照项目编号导出，请在此处输入，否则不用输入；&#13;&#10;2、多个编号间请用 , 隔开；" v-model:value="option.exportIds"></a-textarea>
  </section>
</template>

<script setup>
import { defineProps, ref, watch, onBeforeUnmount, } from 'vue';
import config from '@/config/config';

const props = defineProps({
  option: {
    required: true,
  },
});

onBeforeUnmount(() => {
  console.warn('删除');
  props.option.selectValue = [];
});
</script>

<style lang="scss">
.type-check-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;

  .ant-checkbox-wrapper {
    width: calc(100% / 3.5);
    color: #fff;
    margin-left: 0;
    margin: .1rem 0 ;
  }
}
.code-type{
  margin-top: .2rem;
  p{
    font-size: .18rem;
    margin-bottom: .1rem;
  }
  .ant-input{
    height: 1.5rem;
  }
}
</style>
